import React from 'react'
import PropTypes from 'prop-types'
import autobind from '../../lib/autobind'
import concat from '../../lib/concat-class'

import '../../styles/index.scss'
import '../../styles/navbar/styles.scss'

class Dropdown extends React.Component {
  constructor (props, context) {
    super(props, context)
    autobind(this)

    this.activeDropdown = null
    this.menubarItem = null
    this.submenuItems = []
    this.timeoutID = null
    this.unlisten = null

    this.state = {
      activeItem: null,
      isOpen: false
    }
  }

  getChildContext () {
    return {
      dropdown: {
        closeSubmenu: this.closeSubmenu,
        focusMenubarItem: this.focusMenubarItem,
        focusNextItem: this.focusNextItem,
        focusPrevItem: this.focusPrevItem,
        isOpen: this.state.isOpen,
        openSubmenu: this.openSubmenu,
        registerItem: this.registerItem,
        updateActiveItem: this.updateActiveItem
      }
    }
  }

  closeSubmenu (delay = 50) {
    clearTimeout(this.timeoutID)
    this.timeoutID = setTimeout(() => {
      this.setState({ isOpen: false })
    }, delay)
  }

  focusMenubarItem () {
    this.menubarItem.focus()
  }

  focusNextItem () {
    const { activeItem } = this.state
    const lastIndex = this.submenuItems.length - 1
    const current = this.submenuItems.indexOf(activeItem)
    const next = (current === -1 || current === lastIndex) ? 0 : current + 1
    this.submenuItems[next].focus()
  }

  focusPrevItem () {
    const { activeItem } = this.state
    const lastIndex = this.submenuItems.length - 1
    const current = this.submenuItems.indexOf(activeItem)
    const next = (current === 0) ? lastIndex : current - 1
    this.submenuItems[next].focus()
  }

  openSubmenu () {
    clearTimeout(this.timeoutID)
    this.context.menubar.closeActiveDropdown(this)
    this.context.menubar.setActiveDropdown(this)
    this.setState({ isOpen: true })
  }

  registerItem (element, isMenubarItem = false) {
    if (isMenubarItem) this.menubarItem = element
    else this.submenuItems.push(element)
  }

  updateActiveItem (element) {
    this.setState({ activeItem: element })
  }

  handleOnMouseEnter () {
    this.openSubmenu()
  }

  handleOnMouseLeave () {
    this.closeSubmenu()
  }

  componentDidMount () {
    if (this.context.router) {
      this.unlisten = this.context.router.listen(() => {
        this.closeSubmenu(0)
      })
    }
  }

  componentWillUnmount () {
    if (typeof this.unlisten === 'function') {
      this.unlisten()
    }
  }

  render () {
    const { className, ...props } = this.props
    const hoverClass = this.state.isOpen ? 'navbar__dropdown--dropdown-is-open' : ''
    return (
      <div
        {...props}
        className={concat(className, hoverClass)}
        onMouseEnter={this.handleOnMouseEnter}
        onMouseLeave={this.handleOnMouseLeave}
      >
        {this.props.children}
      </div>
    )
  }
}

Dropdown.contextTypes = {
  router: PropTypes.object,
  menubar: PropTypes.object
}

Dropdown.childContextTypes = {
  dropdown: PropTypes.object
}

export default Dropdown
